import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { User } from '#modules/user/models/user';
import { UsersApiService } from '#modules/user/services/users.api.service';

@Injectable()
export class UserResolver {
    constructor(private readonly _users: UsersApiService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<User> {
        return this._users.getUser(route.params.user_id);
    }
}
